import * as React from 'react'
import {format} from 'date-fns'
import {Link} from '@frontrow/console/src/components/ui/link'
import {Button} from '@frontrow/console/src/components/button'

type Props = {
  owner: string
  createdAt: Date
  loginPassword: string
  resetDemoDistrict: () => void
}

export default function CreatedPanel(props: Props): React.ReactElement {
  const {createdAt, resetDemoDistrict, owner, loginPassword} = props
  return (
    <React.Fragment>
      <p>
        Teacher URL:{' '}
        <Link href="https://classroom-demo.freckle.com">https://classroom-demo.freckle.com</Link>
      </p>
      <p>Username: {owner}</p>
      <p>Password: {loginPassword}</p>
      <br />
      <p>Data last refreshed: {format(createdAt, 'MM/dd/yyyy h:mm a')}</p>
      <p>
        <Button onClick={resetDemoDistrict}>Refresh my demo data</Button>
      </p>
    </React.Fragment>
  )
}
